
import {mapGetters} from 'vuex';
import Sender from '~/api/sender';
import ScheduleList from '~/entities/schedule-list';
import ScheduleRequest from '~/requests/schedule';
import { handleResponse } from 'razlet-sulu-sdk/lib/utils/helpers';
import {debounce} from '~/utils';
// import sulu from '~/mixins/sulu';

function formatCities(res) {
  return res.data;
}

function formatCitiesOne(req, res) {
  return req === '' 
    ? {
      country: '',
      code: '',
      name: '',
    }
    : formatCities(res).map(item => {
      return {
        country: item.country,
        code: item.codeEn,
        name: item.name,
      };
    })[0];
}

export default {
  name: 'schedule-page',
  layout: 'blue',
  // mixins: [sulu],
  async asyncData({route, error}) {
    const {departure, arrival} = route.params;
    const {date} = route.query;

    const request = new ScheduleRequest(date);
    if (departure !== '-') request.from.code = departure;
    if (arrival !== '-') request.to.code = arrival;

    const results = await Promise.allSettled([
      Sender.get(`/asb/cities`, { params: { term: request.from.code } }),
      Sender.get(`/asb/cities`, { params: { term: request.to.code } }),
      Sender.get(`/asb/schedule`, { params: request.buildRequest(!date)}),
    ]);

    const [from, to, list] = handleResponse(results, error);

    return {
      departure: formatCitiesOne(request.from.code, from),
      arrival: formatCitiesOne(request.to.code, to),
      list: list ? list.data : null,
      firstDate: list ? list.data.firstDay || date : null,
    };
  },
  data() {
    return {
      request: null,
      firstDate: null,
      departure: {},
      arrival: {},
      list: null,
      schedule: {},
      loading: true,
      backLoading: true,
      dbLoadSchedule: debounce(this.loadSchedule, 400),
      dbLoadAvailable: debounce(this.loadAvailable, 400),
      dbLoadPrices: debounce(this.loadPrices, 400),
      weekWatchers: null,
      citiesWatchers: null,
      dateWatchers: null,
    };
  },
  computed: {
    ...mapGetters([
      'getPricesStatistic',
      'hasPrices',
    ]),
  },
  created() {
    this.request = new ScheduleRequest(this.firstDate);
    this.fill();
  },
  mounted() {
    this.createWatchers();
    this.loadAvailable();
    this.loadPrices();
    this.$bus.$on('locale-changed', () => {
      this.backLoading = true;
      window.scrollTo(0, 0);
      this.$nuxt.refresh().then(() => {
        this.destroyWatchers();
        this.fill();
        this.createWatchers();
        this.loadAvailable();
        this.loadPrices();
      });
    });
  },
  methods: {
    fill() {
      if (this.departure && this.departure.code) this.request.from = this.departure;
      if (this.arrival && this.arrival.code)  this.request.to = this.arrival;

      this.createSchedule(this.list);
      this.backLoading = false;
      this.loading = false;
    },
    destroyWatchers() {
      this.weekWatchers();
      this.citiesWatchers();
      this.dateWatchers();
    },
    loadSchedule() {
      this.loading = true;
      Sender.get(`/asb/schedule`, { params: this.request.buildRequest() })
        .then(res => {
          this.createSchedule(res.data);
          this.$forceNextTick(() => this.$nuxt.$emit('schedule-loaded'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadAvailable() {
      this.request.availableDates = [];
      Sender.get(`/asb/dates`, { params: this.request.buildDatesRequest() })
        .then(res => {
          this.request.availableDates = res.data;
        });
    },
    loadPrices() {
      Sender.get(`/asb/prices`, { params: this.request.buildPricesRequest() })
        .then(res => {
          if (res.status === 200) this.$store.commit('modifyPricesStatistic', res.data);
        });
    },
    nextWeek() {
      this.request.nextWeek();
      window.scrollTo({top: 0});
    },
    prevWeek() {
      this.request.prevWeek();
      window.scrollTo({top: 0});
    },
    createSchedule(res) {
      if (res) this.schedule = new ScheduleList(this.request, res);
    },
    createWatchers () {
      this.citiesWatchers = this.$watch(vm => [vm.request.from.code, vm.request.to.code], () => {
        this.dbLoadSchedule();
        this.dbLoadAvailable();
        this.changeUrlWithoutRender();
        this.dbLoadPrices();
      }, {
        deep:true,
      });
      this.dateWatchers = this.$watch(vm => [vm.request.dateBasis], () => {
        this.request.setWeek(this.request.dateBasis);
      });
      this.weekWatchers = this.$watch(vm => [vm.request.week], () => {
        this.loading = true;
        this.request.weekChanged(this.request.week);
        this.changeUrlWithoutRender(this.request.week.from);
        this.dbLoadSchedule();
      }, {
        deep: true,
      });
    },
    changeUrlWithoutRender(date = '') {
      const newUrl = this.$router.resolve({ 
        name: 'passazhiram-schedule-departure-arrival', 
        params: { 
          departure: this.request.from.code || '-', 
          arrival: this.request.to.code || '-',
        },
        query: {
          ...date && {
            date: `${date.year}-${date.month.value}-${date.date}`,
          },
        },
      });
      if (date) window.history.replaceState({}, null, newUrl.href);
      else window.history.pushState({}, null, newUrl.href);
    },
  },
};
